<template>
  <b-container fluid>
    <b-card no-body>
      <b-overlay
        :show="isLoading"
        rounded="sm"
      >
        <div class="m-2">
          <b-row>
            <b-col
              cols="12"
              md="6"
              lg="8"
            >
              <b-form-group
                label-for="factAdmissionCriteriaTypeId"
              >
                <v-select
                  v-model="filter.factAdmissionCriteriaTypeId"
                  :options="dataAdmissionCriteriaTypes"
                  :reduce="option => option.value"
                  placeholder="Loại tiêu chí"
                />
              </b-form-group>
            </b-col>
            <b-col
              cols="12"
              lg="4"
            >
              <b-row>
                <b-col
                  cols="12"
                  class="text-right"
                >
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    size="sm"
                    class="mr-1"
                    @click="btnSearchClick()"
                  >
                    <feather-icon
                      icon="SearchIcon"
                      class="align-text-top"
                    />
                    Tìm kiếm
                  </b-button>
                  <b-button
                    v-if="creatable"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    v-b-modal.saveModal
                    variant="success"
                    size="sm"
                    class=""
                    @click="onCreate"
                  >
                    <span class="text-nowrap text-right">
                      <feather-icon icon="PlusIcon" /> Thêm mới
                    </span>
                  </b-button>
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <b-row class="">
            <b-col cols="12">
              <vue-good-table
                mode="remote"
                :columns="columns"
                :rows="criteriaSets"
                :pagination-options="paginationOptions"
                :total-rows="totalRows"
                :line-numbers="true"
                :row-style-class="rowStyleClassFn"
                @on-page-change="onPageChange"
                @on-sort-change="onSortChange"
                @on-column-filter="onColumnFilter"
                @on-per-page-change="onPerPageChange"
                @on-row-click="onRowClick"
              >
                <div
                  slot="emptystate"
                  style="text-align: center; font-weight: bold"
                >
                  Không có bản ghi nào !
                </div>
                <template
                  slot="table-row"
                  slot-scope="props"
                >
                  <span v-if="props.column.field === 'status'">
                    {{ getStatusName(props.row.status) }}
                  </span>

                  <span
                    v-else-if="props.column.field === 'action'"
                    class="thead-group-action"
                  >
                    <b-dropdown
                      variant="link"
                      no-caret
                      :right="$store.state.appConfig.isRTL"
                    >
                      <template #button-content>
                        <feather-icon
                          icon="MoreVerticalIcon"
                          size="16"
                          class="align-middle text-body"
                        />
                      </template>
                      <b-dropdown-item
                        v-if="updatable"
                        v-b-modal.saveModal
                        @click="onEdit(props.row)"
                      >
                        <feather-icon icon="EditIcon" />
                        <span class="align-middle ml-50">Sửa</span>
                      </b-dropdown-item>

                      <b-dropdown-item
                        v-if="criteriaCreatable"
                        v-b-modal.criteriaSaveModal
                        @click="onCreateCriteria(props.row)"
                      >
                        <feather-icon icon="PlusIcon" />
                        <span class="align-middle ml-50">Thêm tiêu chí</span>
                      </b-dropdown-item>
                      <b-dropdown-item
                        v-if="criteriaCreatable"
                        v-b-modal.criteriaCopyModal
                        @click="onCopyCriteria(props.row)"
                      >
                        <feather-icon icon="CopyIcon" />
                        <span class="align-middle ml-50">Sao chép bộ tiêu chí</span>
                      </b-dropdown-item>
                      <b-dropdown-item
                        v-if="deletable"
                        @click="onDelete(props.row)"
                      >
                        <feather-icon icon="TrashIcon" />
                        <span class="align-middle ml-50">Xóa</span>
                      </b-dropdown-item>
                    </b-dropdown>
                  </span>
                  <span v-else>{{ props.formattedRow[props.column.field] }}</span>
                </template>
                <template
                  slot="pagination-bottom"
                  slot-scope="props"
                >
                  <div class="d-flex justify-content-between flex-wrap">
                    <div class="d-flex align-items-center ml-1 mb-1 mt-1">
                      <span class="text-nowrap"> Hiển thị {{ filter.itemsPerPage * (filter.currentPage-1) +1 }}
                        đến {{ filter.itemsPerPage * (filter.currentPage) }} &nbsp; của {{ totalRows }} bản ghi
                      </span>
                    </div>
                    <div class="d-flex align-items-center mb-1 mt-1">
                      <span class="text-nowrap"> Hiển thị </span>
                      <b-form-select
                        v-model="filter.itemsPerPage"
                        :options="itemsPerPageOptions"
                        class="mx-1"
                        @input="(value) => props.perPageChanged({ currentPerPage: value })"
                      />
                      <span class="text-nowrap"> bản ghi/trang</span>
                    </div>
                    <div>
                      <b-pagination
                        :value="1"
                        :total-rows="totalRows"
                        :per-page="filter.itemsPerPage"
                        class="mt-1 mb-0"
                        @input="(value) => props.pageChanged({ currentPage: value })"
                      />
                    </div>
                  </div>
                </template>
              </vue-good-table>
            </b-col>
          </b-row>
        </div>
      </b-overlay>
    </b-card>
    <Save
      ref="saveModalRef"
      :item="currentCriteriaSet"
      @succeed="onSucceed"
    />
    <CriteriaIndex
      :criteria-set-id="currentCriteriaSet ? currentCriteriaSet.id : null"
      :criteria-set-name="currentCriteriaSet ? currentCriteriaSet.name : ''"
      @onLoading="setLoading"
      @onUpdateCriteria="setCriteria"
    />
    <CriteriaSave
      :criteria-set-id="currentCriteriaSet ? currentCriteriaSet.id : null"
      :check="currentCriteriaSet ? (currentCriteriaSet.factAdmissionCriteriaTypeCode === 'TCĐGĐV') : false"
      :criteria="currentCriteria"
      @succeed="onSucceedCreateCriteria"
    />
    <CriteriaCopy
      ref="criteriaCopyModalRef"
      :main-data="currentMainData"
      @succeed="onSucceed"
    />
  </b-container>
</template>

<script>
import {
  BButton,
  BCard,
  BCol,
  BContainer, BDropdown, BDropdownItem,
  BFormGroup,
  BFormSelect,
  BOverlay,
  BPagination,
  BRow,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import { mapActions, mapGetters } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import '@core/scss/vue/libs/vue-good-table.scss'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import Save from '@/views/admission/criteria-set/Save.vue'
import { getUser } from '@/auth/utils'
import { hasPermissionForResource, isSystemAdmin } from '@/utils'
import { PermissionCode, ResourceCode } from '@/const/code'
import CriteriaSave from '@/views/admission/criteria/CriteriaSave.vue'
import CriteriaIndex from '@/views/admission/criteria/CriteriaIndex.vue'
import CriteriaCopy from '@/views/admission/criteria-set/CriteriaCopy.vue'

export default {
  name: 'Index',
  directives: {
    Ripple,
  },
  components: {
    CriteriaCopy,
    CriteriaIndex,
    CriteriaSave,
    BDropdown,
    BDropdownItem,
    BButton,
    BCard,
    BCol,
    BContainer,
    BFormSelect,
    BOverlay,
    BPagination,
    BRow,
    BFormGroup,
    VueGoodTable,
    vSelect,
    Save,
  },
  data() {
    return {
      user: getUser(),
      isLoading: false,
      filter: {
        currentPage: 1,
        itemsPerPage: 10,
        organizationId: getUser().orgId,
        factAdmissionCriteriaTypeId: null,
        searchTerm: '',
        sort: '',
      },
      currentCriteriaSet: undefined,
      paginationOptions: {
        enabled: true,
      },
      currentMainData: undefined,
      itemsPerPageOptions: [10, 20, 30, 50, 80, 100],
      currentCriteria: undefined,
    }
  },
  computed: {
    ...mapGetters({
      criteriaSets: 'criteriaSet/criteriaSets',
      totalRows: 'admissionCommittee/totalRows',
      statuses: 'admissionCommittee/statuses',
      dataAdmissionCriteriaTypes: 'factAdmissionCriteriaType/dataAdmissionCriteriaTypes',
    }),
    columns() {
      return [
        {
          label: 'STT',
          field: 'rowNum',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'Mã',
          field: 'code',
          sortable: true,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'Tên bộ tiêu chí',
          field: 'name',
          sortable: true,
          thClass: 'text-center',
        },
        {
          label: 'Loại tiêu chí',
          field: 'factAdmissionCriteriaTypeName',
          sortable: true,
          thClass: 'text-center',
        },
        {
          label: 'Trạng thái',
          field: 'status',
          filterOptions: {
            placeholder: 'Tất cả',
            enabled: true,
            trigger: 'enter',
            filterDropdownItems: this.statusFilterDropdownItems,
          },
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: '',
          field: 'action',
          width: '80px',
          sortable: false,
          tdClass: 'text-center',
        },
      ]
    },
    statusFilterDropdownItems() {
      return this.statuses.map(status => ({ value: status.value, text: status.label }))
    },
    creatable() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.CREATE, ResourceCode.CRITERIA_SET)
    },
    updatable() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.UPDATE, ResourceCode.CRITERIA_SET)
    },
    deletable() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.DELETE, ResourceCode.CRITERIA_SET)
    },
    criteriaCreatable() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.CREATE, ResourceCode.CRITERIA_SET)
    },
  },
  async created() {
    this.isLoading = true
    try {
      await this.getAdmissionCriteriaTypes()
      await this.readCriteriaSets(this.filter)
    } catch (e) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: `[${e.code}] ${e.message}`,
          icon: 'XCircleIcon',
          variant: 'danger',
        },
      })
    } finally {
      this.isLoading = false
    }
  },
  methods: {
    ...mapActions({
      readCriteriaSets: 'criteriaSet/readCriteriaSets',
      deleteCriteriaSets: 'criteriaSet/deleteCriteriaSets',
      getAdmissionCriteriaTypes: 'factAdmissionCriteriaType/getAdmissionCriteriaTypes',
      getCriteria: 'criteria/getCriteria',
    }),
    async btnSearchClick() {
      this.isLoading = true
      try {
        await Promise.all([
          this.readCriteriaSets(this.filter),
        ])
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `[${e.code}] ${e.message}`,
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.isLoading = false
      }
    },
    onCreate() {
      this.currentCriteriaSet = undefined
    },
    onEdit(admissionCommittee) {
      const {
        rowNum,
        originalIndex,
        vgt_id,
        ...rest
      } = admissionCommittee
      this.currentCriteriaSet = rest
    },
    onCopyCriteria(mainData) {
      const {
        rowNum,
        originalIndex,
        vgt_id,
        ...rest
      } = mainData
      this.currentMainData = rest
    },
    onDelete(criteriaSet) {
      this.$swal({
        title: `Bạn chắc chắn muốn xóa bộ tiêu chí <span class="text-danger">${criteriaSet.name}</span>?`,
        text: 'Bạn sẽ không thể khôi phục lại dữ liệu này!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '<i class="fa-solid fa-check"></i> Đồng ý',
        cancelButtonText: '<i class="fa-solid fa-times"></i> Hủy',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(async result => {
        if (result.value) {
          this.isLoading = true
          try {
            const response = await this.deleteCriteriaSets(criteriaSet.id)
            if (response) {
              const { isSuccessful, message } = response
              if (isSuccessful) {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: message,
                    icon: 'CheckIcon',
                    variant: 'success',
                  },
                })
                try {
                  await this.readCriteriaSets(this.filter)
                } catch (e) {
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: `[${e.code}] ${e.message}`,
                      icon: 'XCircleIcon',
                      variant: 'danger',
                    },
                  })
                }
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: message,
                    icon: 'XCircleIcon',
                    variant: 'danger',
                  },
                })
              }
            }
          } catch (e) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: `[${e.code}] ${e.message}`,
                icon: 'XCircleIcon',
                variant: 'danger',
              },
            })
          } finally {
            this.isLoading = false
          }
        }
      })
    },
    setLoading(value) {
      this.isLoading = value
    },
    onCreateCriteria(criteria) {
      this.setCurrentCriteriaSet(criteria)
      this.currentCriteria = undefined
    },
    async onSucceedCreateCriteria() {
      this.isLoading = true
      try {
        await this.getCriteria({ criteriaSetId: this.currentCriteriaSet.id })
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `[${e.code}] ${e.message}`,
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.isLoading = false
      }
    },
    updateParams(newProps) {
      this.filter = { ...this.filter, ...newProps }
    },
    async onPageChange(param) {
      this.updateParams({ currentPage: param.currentPage })
      await this.getDataFromStore()
    },
    async getDataFromStore() {
      this.isLoading = true
      try {
        await this.readCriteriaSets(this.filter)
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `[${e.code}] ${e.message}`,
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.isLoading = false
      }
    },
    async onPerPageChange(param) {
      this.updateParams({ currentPage: 1, itemsPerPage: param.currentPerPage })
      await this.getDataFromStore()
    },
    async onSortChange(param) {
      if (param.length > 0) {
        const { field, type } = param[0]
        if (field === 'name') this.updateParams({ sort: `1_${type}` })
        else if (field === 'code') this.updateParams({ sort: `2_${type}` })
        else if (field === 'orderNo') this.updateParams({ sort: `3_${type}` })
        else this.updateParams({ sort: `3_${type}` })
      }
      await this.getDataFromStore()
    },
    async onColumnFilter(param) {
      const { columnFilters } = param
      if (Object.hasOwn(columnFilters, 'code')) this.updateParams({ searchTerm: columnFilters.code })
      if (Object.hasOwn(columnFilters, 'name')) this.updateParams({ searchTerm: columnFilters.name })
      if (Object.hasOwn(columnFilters, 'status')) this.updateParams({ status: columnFilters.status })
      await this.getDataFromStore()
    },
    onRowClick(param) {
      const { row } = param
      this.setCurrentCriteriaSet(row)
    },
    setCurrentCriteriaSet(criteria) {
      const {
        rowNum,
        originalIndex,
        vgt_id,
        ...rest
      } = criteria
      this.currentCriteriaSet = rest
    },
    getStatusName(id) {
      return this.statuses.find(status => status.value === id).label
    },
    async onSucceed() {
      await this.getDataFromStore()
    },
    setCriteria(value) {
      this.currentCriteria = value
    },
    rowStyleClassFn(row) {
      return this.currentCriteriaSet && row.id === this.currentCriteriaSet.id ? 'row-selected' : ''
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.row-selected {
  background-color: rgba(251, 205, 68, 0.89);
  color: #FFF;
}
</style>
